/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
}));

const CellStartTime = ({ row = {} }) => {
  const history = useHistory();
  const classes = useStyles();
  const { original = {} } = row;
  const { _id = '', startTime = '' } = original;

  const handleRedirectToAlgoEdit = () => {
    history.push(`/algos/${_id}`, {
      from: window.location.hash,
    });
  };

  return (
    <div className={classes.root} onClick={handleRedirectToAlgoEdit}>
      {startTime}
    </div>
  );
};

export default CellStartTime;
